import type { OnChangeValue, Options } from "react-select";

import type { DropdownOption } from "../CountryDropdown/UI";
import UI from "./UI";

const selectStyle = () => {
  return {
    menu: (provided: any) => ({
      ...provided,
      zIndex: 10,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: "#FFFCF9",
      color: state.isSelected ? "#292929" : "#676767",
      fontSize: "16px",
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      padding: "0px",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#292929",
      padding: "12px 0px",
      margin: "0px",
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      background: "transparent",
    }),

    placeholder: (provided: any) => ({
      ...provided,
      color: "#757575",
      marginBottom: "5px",
    }),
    control: (provided: any) => ({
      ...provided,

      border: "none",
      borderBottom: "1px solid var(--color-divider)",
      borderRadius: "0px",
      fontSize: "16px",
      background: "transparent",
      color: "#292929",
      boxShadow: "none!important",

      ":hover": {
        boxShadow: "none",
        borderColor: "#6C6961",
      },
    }),
  };
};

interface DropdownProps {
  options: Options<DropdownOption>;
  onChange: (newValue: OnChangeValue<DropdownOption, false>) => void;
  value: string;
  markets?: boolean;
  placeholder?: string;
  disableSearch?: boolean;
  defaultNull?: boolean;
}
const Dropdown = ({
  options,
  onChange,
  value,
  markets = false,
  placeholder,
  defaultNull = false,
  disableSearch = false,
}: DropdownProps) => {
  const styles = selectStyle();

  const currentValue =
    options.find((option) => option.value === value) ||
    (placeholder || defaultNull ? undefined : options[0]);

  return (
    <UI
      options={options}
      onChange={onChange}
      styles={styles}
      value={currentValue}
      disableSearch={disableSearch}
      markets={markets}
      placeholder={placeholder}
    />
  );
};

export default Dropdown;
